<i18n>
{
  "fr": {
    "configuratorCrossSellModalHeader": {
      "advertisment": "Vos gobelets existent dans d'autres formats ! Complétez votre commande et économisez :",
      "promotionTag": {
        "text5": "2 formats achetés =",
        "reduction5": "-5%",
        "text10": "3 formats achetés =",
        "reduction10": "-10%"
      }
    }
  }
}
</i18n>

<template>
  <div :class="`${BASE_SELECTOR}`">
    <div :class="`${BASE_SELECTOR}__advertisment`">
      {{ $t('configuratorCrossSellModalHeader.advertisment') }}
    </div>

    <div :class="`${BASE_SELECTOR}__promotion-tags-wrapper`">
      <ConfiguratorCrossSellPromotionTag
        :class="`${BASE_SELECTOR}__promotion-tag ${BASE_SELECTOR}__promotion-tag--5`"
        :text="$t('configuratorCrossSellModalHeader.promotionTag.text5')"
        :reduction="
          $t('configuratorCrossSellModalHeader.promotionTag.reduction5')
        "
      />
      <ConfiguratorCrossSellPromotionTag
        :class="`${BASE_SELECTOR}__promotion-tag ${BASE_SELECTOR}__promotion-tag--10`"
        :text="$t('configuratorCrossSellModalHeader.promotionTag.text10')"
        :reduction="
          $t('configuratorCrossSellModalHeader.promotionTag.reduction10')
        "
      />
      <span :class="`${BASE_SELECTOR}__flute`"></span>
      <span :class="`${BASE_SELECTOR}__wine-glass`"></span>
      <img :class="`${BASE_SELECTOR}__golden-star`" :src="GoldenStar" alt="" />
    </div>
  </div>
</template>

<script>
import ConfiguratorCrossSellPromotionTag from './ConfiguratorCrossSellPromotionTag.vue';
import GoldenStar from '../../../../../resources/images/configurator/static/golden-star.svg';

export default {
  name: 'ConfiguratorCrossSellModalHeader',
  components: {
    ConfiguratorCrossSellPromotionTag,
  },
  data() {
    return {
      BASE_SELECTOR: 'configurator-cross-sell-modal-header',
      GoldenStar,
    };
  },
};
</script>

<style lang="scss" scoped>
.configurator-cross-sell-modal-header {
  display: flex;
  flex-direction: column;
  background-color: $color-arapawa;
  padding: 1rem 1.1563rem 1.5rem;
  overflow: hidden;
  gap: 0.75rem;

  @include breakpoint($breakpoint-l) {
    flex-direction: row;
    padding: 1.25rem 1.875rem;
    min-height: 9.375rem;
    align-items: center;

    & > * {
      flex: 1;
    }
  }

  &__advertisment {
    color: white;
    text-align: center;
    z-index: 1;

    @include breakpoint($breakpoint-l) {
      text-align: left;
    }
  }

  &__promotion-tags-wrapper {
    position: relative;
    min-height: 4.6875rem;
  }

  &__promotion-tag {
    z-index: 10;

    &--5 {
      position: absolute;
      transform: rotate(-2.3deg);
    }

    &--10 {
      position: absolute;
      transform: rotate(2.5deg);
      left: 32%;
      top: 65%;
    }

    @include breakpoint($breakpoint-l) {
      &--5 {
        position: absolute;
        top: 0;
        left: 15%;
        transform: rotate(-2.3deg);
      }

      &--10 {
        position: absolute;
        top: 75%;
        left: 5%;
        transform: rotate(2.5deg);
      }
    }
  }

  &__flute {
    position: absolute;
    top: -20%;
    left: 60%;
    color: $color-brown-twine;
    font-size: 3.5rem;
    transform: rotate(20deg);

    &::before {
      @extend %icon;
      @extend %icon--flute;
    }

    @include breakpoint($breakpoint-l) {
      left: 0;
      top: 0;
    }
  }

  &__wine-glass {
    position: absolute;
    top: 45%;
    left: 15%;
    color: $color-blue-cerulean-blue;
    transform: rotate(-20deg);
    font-size: 4rem;

    &::before {
      @extend %icon;
      @extend %icon--cupWineglass;
    }

    @include breakpoint($breakpoint-l) {
      left: 80%;
      top: 50%;
      z-index: 10;
      font-size: 3rem;
    }
  }

  &__golden-star {
    position: absolute;
    top: 0;
    right: 0;
    width: 6.875rem;
    height: 6.875rem;
    object-fit: contain;

    @include breakpoint($breakpoint-l) {
      top: -50%;
      right: 8%;
    }
  }

  &__close-button {
    position: absolute;
    top: 0;
    right: 0;
    width: 2.5rem;
    height: 2.5rem;
    object-fit: contain;
    display: flex;
    color: $color-white;
    background-color: transparent;

    &::before {
      @extend %icon;
      @extend %icon--close;
    }
  }
}
</style>
